import {
  KeyReplacementRatesQuery,
  useKeyReplacementRatesLazyQuery,
} from '../../../../gql/generated/graphql';

import CalcProductButton, { ProductButtonConfig } from './CalcProductButton';

import { PermissionEnum } from '../../../../constants/permissions';

const keyReplacementConfig: ProductButtonConfig<KeyReplacementRatesQuery> = {
  permission: PermissionEnum.CalculateKeyReplacement,
  buttonText: 'CALC KEY',
  loadingText: 'CALC KEY',
  successMessage: 'Key Replacement rate retrieved successfully',
  errorMessage: 'Failed to retrieve Key Replacement rate',
  costField: 'key_replacement_cost',
  priceField: 'key_replacement_price',
  useRatesQuery: useKeyReplacementRatesLazyQuery,
  extractRate: (data) => data?.keyReplacementRates?.[0]?.deductible ?? undefined,
};

const CalcKeyReplacementButton = ({ onRatesLoaded }: { onRatesLoaded?: () => void }) => (
  <CalcProductButton config={keyReplacementConfig} onRatesLoaded={onRatesLoaded} />
);

export default CalcKeyReplacementButton;
